import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserCapitalCashFlow } from "layouts/applications/data-tables/data/getData";

const initialState = {
  capital: 0,
  cashFlow: 0,
};

export const loadUserCapital = createAsyncThunk("portfolio/capital", async () => {
  const userCapital = await getUserCapitalCashFlow();
  return userCapital;
});

export const portfolioSlice = createSlice({
  name: "userCapital",
  initialState,
  reducers: {
    depositCapital: (state, action) => {
      state.capital += parseFloat(action.payload);
      state.cashFlow += parseFloat(action.payload); // adding capital will also affect the cash flow
    },
    withdrawCapital: (state, action) => {
      state.capital -= parseFloat(action.payload);
      state.cashFlow -= parseFloat(action.payload); // withdraw capital will also affect the cash flow
    },
    buyStock: (state, action) => {
      state.cashFlow -= parseFloat(action.payload);
    },
    sellStock: (state, action) => {
      const { capital, pAndL } = action.payload; // pnl can be + or -
      state.cashFlow += parseFloat(capital) + parseFloat(pAndL);
      state.capital += parseFloat(pAndL); // selling stock affect the capital by pnl
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadUserCapital.fulfilled, (state, action) => {
      if (!action.payload) return;

      const { capital, cash_flow } = action.payload;
      state.capital = capital;
      state.cashFlow = cash_flow;
    });
  },
});

// Action creators are generated for each case reducer function
export const { depositCapital, withdrawCapital, buyStock, sellStock } = portfolioSlice.actions;

export default portfolioSlice.reducer;
